/**
 * Created by alvinoktavianus on 5/12/17.
 */

import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
  SETTING_BILLING_PAY_BUTTON_MESSAGE,
  SETTING_BILLING_SET_BILLINGS,
  SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_SET_IS_DELETED_OUTLET,
  SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
  SETTING_BILLING_SET_OUTLETS,
  SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
  SETTING_BILLING_SET_RULES,
  SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
  SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
  SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
  SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
} from 'actions/setting/billing/constant'

let initialState = {
  billings: [],
  outlets: {},
  rules: {},
  featureSubscriptionStatus: [],
  countFeatureSubscription: 0,
  currentSubscriptionRules: {},
  payButtonClicked: false,
  buttonMessage: 'Pay',
  showPaymentGatewayErrorModal: false,
  totalBillingPrice: 0,
  pendingPaymentMessage: null,
  unusedOutletMessage: null,
  currentSubscriptionPlanName: null,
  showCancelFeatureSubscriptionModal: false,
  cancelFeatureSubscriptionModalData: {},
  featureSubscriptionPrice: {},
  outletMinMaxDate: {},
  showBillingPage: true,
  isDeleted: {}
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  const {payload = {}} = action

  switch (action.type) {
    case SETTING_BILLING_SET_BILLINGS:
      return {...state, billings: payload.data}
    case SETTING_BILLING_SET_OUTLETS:
      return {...state, outlets: payload.data}
    case SETTING_BILLING_SET_RULES:
      return {...state, rules: payload.data}
    case SETTING_BILLING_SET_SUBSCRIPTION_STATUS:
      return {...state, featureSubscriptionStatus: payload.data}
    case SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES:
      return {...state, currentSubscriptionRules: payload.newSubscriptionRules}
    case SETTING_BILLING_IS_CLICKED_BUTTON_PAY:
      return {...state, payButtonClicked: payload.payButtonClicked}
    case SETTING_BILLING_PAY_BUTTON_MESSAGE:
      return {...state, buttonMessage: payload.payButtonMessage}
    case SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: true}
    case SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: false}
    case SETTING_BILLING_SET_TOTAL_BILLING_PRICE:
      return {...state, totalBillingPrice: payload.totalBillingPrice}
    case SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE:
      return {...state, pendingPaymentMessage: payload.pendingPaymentMessage}
    case SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE:
      return {...state, unusedOutletMessage: payload.unusedOutletMessage}
    case SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME:
      return {...state, currentSubscriptionPlanName: payload.planName}
    case SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION:
      return {...state, countFeatureSubscription: payload.countFeatureSubscription}
    case SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return {...state, showCancelFeatureSubscriptionModal: true}
    case SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return {...state, showCancelFeatureSubscriptionModal: false}
    case SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return {...state, cancelFeatureSubscriptionModalData: payload.featureSubscriptionModalData}
    case SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE:
      return {...state, featureSubscriptionPrice: payload.featureSubscriptionPrice}
    case SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE:
      return {...state, outletMinMaxDate: payload.minMaxDate}
    case SETTING_BILLING_SET_IS_DELETED_OUTLET:
      return {...state, isDeleted: payload.isDeleted}
    default:
      return {...state}
  }
}

export { reducer }



// WEBPACK FOOTER //
// ./app/reducers/setting/billing.js